import { Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { Agency } from '@adgate/common/types/agency.type';
import { CommercialOffice } from '@adgate/common/types/commercial-office.type';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomValidators } from '@adgate/common/validators/custom-validators.validator';
import { AdminService } from '@adgate/modules/admin/services/admin-service';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';
import { DialogService } from '@adgate/common/services/dialog-service';
import { ComparatorService } from '@adgate/common/services/comparator-service';
import { ObjectDescPipe } from '@adgate/common/pipes/object-desc-pipe';

@Component({
  selector: 'app-agency-edit-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    ObjectDescPipe
  ],
  templateUrl: './agency-edit-dialog-component.html',
  styleUrl: './agency-edit-dialog-component.scss',
})
export class AgencyEditDialogComponent implements OnInit
{
  private dialogRef: MatDialogRef<AgencyEditDialogComponent> = inject(MatDialogRef);
  private fb: FormBuilder = inject(FormBuilder);
  private adminService: AdminService = inject(AdminService);
  private dialogService: DialogService = inject(DialogService);
  public comparatorService: ComparatorService = inject(ComparatorService);

  public data: Agency = inject(MAT_DIALOG_DATA, { optional: false });

  public offices: CommercialOffice[] = [];
  agencyForm: FormGroup;

  constructor()
  {
    this.agencyForm = this.fb.group({
      agency: ['', [Validators.required, CustomValidators.invalidCharactersValidator()]],
      commercialOffices: [[], [Validators.required]],
      externalId: ['']
    });
  }

  ngOnInit(): void
  {
    this.dialogService.showProgress();
    this.adminService.getCommercialOffices().subscribe({
      next: (r:RESTApplicationResponse) => {
        this.offices = r.data;

        if( this.data?.id != -1 ) {
          this.agencyForm.get('agency')?.setValue(this.data?.description);
          this.agencyForm.get('commercialOffices')?.setValue(this.data?.offices);
          this.agencyForm.get('externalId')?.setValue(this.data?.externalId);
        }

        this.dialogService.hideProgress();
      },
      error: (err: Error) => {
        this.dialogService.openErrorDialog(err.message);
      }
    });
  }

  onCancel(): void
  {
    this.dialogRef.close(null);
  }

  onSubmit(): void
  {
    if( this.agencyForm.valid ) {
      this.data.description = this.agencyForm.get('agency')?.value;
      this.data.offices = this.agencyForm.get('commercialOffices')?.value;
      this.data.externalId = this.agencyForm.get('externalId')?.value;

      this.dialogRef.close( this.data );
    }
  }
}
